import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imageUrl } from "@/lib/api";
import { useChampionship } from "@/context/ChampionshipContext";

export default function NewsPage() {
  const { current } = useChampionship() || {};
  const [news, setNews] = useState([]);

  useEffect(() => {
    if (!current?.id) return;
    api.get(`/championships/${current.id}/news`).then((r) => setNews(r.data || []));
  }, [current?.id]);

  const featured = news.filter((n) => n.is_featured);
  const blog = news.filter((n) => !n.is_featured);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="news-page">
      <div className="border-b border-border pb-10 mb-12">
        <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">
          {current?.year} — {current?.location}
        </div>
        <h1 className="font-display text-5xl md:text-7xl font-extrabold tracking-tighter mt-3">News</h1>
      </div>

      {featured.length > 0 && (
        <section className="mb-16">
          <div className="text-[11px] uppercase tracking-[0.25em] text-primary mb-6">Featured</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {featured.map((n) => (
              <NewsArticleCard key={n.id} article={n} big />
            ))}
          </div>
        </section>
      )}

      <section>
        <div className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground mb-6">All updates</div>
        {blog.length === 0 ? (
          <div className="text-muted-foreground">No updates yet.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {blog.map((n) => (
              <NewsArticleCard key={n.id} article={n} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

function NewsArticleCard({ article, big }) {
  return (
    <Link to={`/news/${article.slug}`} className="group block" data-testid={`news-${article.slug}`}>
      <div className={`bg-neutral-100 overflow-hidden border border-border ${big ? "aspect-[16/10]" : "aspect-[4/3]"}`}>
        {article.image_path ? (
          <img src={imageUrl(article.image_path)} alt="" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
        ) : (
          <div className="h-full w-full bg-foreground" />
        )}
      </div>
      <div className="mt-4">
        <div className="text-xs uppercase tracking-wider text-muted-foreground mb-2">
          {new Date(article.published_at).toLocaleDateString()}
        </div>
        <h3 className={`font-display font-bold group-hover:text-primary transition-colors tracking-tight ${big ? "text-3xl" : "text-xl"}`}>
          {article.title}
        </h3>
        {article.excerpt && <p className="mt-2 text-sm text-muted-foreground line-clamp-3">{article.excerpt}</p>}
      </div>
    </Link>
  );
}
